import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'; 

@Component({
  selector: 'app-conversion-units-dialog',
  template: `
  <div class="container">
    <h2 mat-dialog-title>{{data.title}}</h2>
    <form [formGroup]="form">
      <mat-dialog-content>
        <div class="form-group">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Unidad de Medida Principal (o de Almacenamiento)</mat-label>
            <mat-select formControlName="baseMeasurementUnitId">
              <mat-option *ngFor="let unit of data.units" [value]="unit.id">
                {{unit.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Unidad de Medida Alternativa (o de Compra/Venta)</mat-label>
            <mat-select formControlName="measurementUnitId">
              <mat-option *ngFor="let unit of data.units" [value]="unit.id">
                {{unit.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Equivalencia</mat-label>
            <input matInput type="number" formControlName="quantity">
          </mat-form-field>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="onNoClick()">Cancelar</button>
        <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onSave()">
          Guardar
        </button>
      </mat-dialog-actions>
    </form>
    </div>
  `,
  styles: [`
    .container { padding: 2px; }
    .w-100 { width: 100%; }
    .form-group { margin-bottom: 1rem; }
  `]
})
export class ConversionUnitsDialogComponent implements OnInit {
  form: FormGroup;
  articleId: number;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ConversionUnitsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.articleId = Number.parseInt(data.articleId, 10);
  }

  ngOnInit() {
    this.form = this.fb.group({
      measurementUnitId: ['', Validators.required],
      baseMeasurementUnitId: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.min(0)]]
    });

    if (this.data.conversionUnit) {
      this.form.patchValue(this.data.conversionUnit);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.form.valid) {
      const data = {
        ...this.form.value,
        articleId: this.articleId
      };
      this.dialogRef.close(data);
    }
  }
}